var store={
  openModal:'',
}
window.store=store;
export default store
